<template>
  <div class="enter-container">
    <div class="common-container">
      <div class="common-title">
        <h2>入驻我们的流程</h2>
        <p>入驻融媒开放平台，获取更多开放服务</p>
      </div>

      <ul class="enter-list">
        <li
          class="bounceInUpSlow wow"
          style="visibility: visible; animation-name: bounceInUpSlow"
        >
          <a href="##">
            <div class="icon">
              <img src="@/assets/images/speed-img01.png" alt="" />
            </div>
            <h4>注册认证</h4>
            <p>填写表单注册成为融媒开放平台的开发者</p>
          </a>
        </li>
        <li
          class="bounceInUpSlow wow"
          data-wow-delay="0.15s"
          style="
            visibility: visible;
            animation-delay: 0.15s;
            animation-name: bounceInUpSlow;
          "
        >
          <a href="##">
            <div class="icon">
              <img src="@/assets/images/speed-img02.png" alt="" />
            </div>
            <h4>创建应用</h4>
            <p>登录后在开发者中心，创建应用，管理和设置应用</p>
          </a>
        </li>
        <li
          class="bounceInUpSlow wow"
          data-wow-delay="0.3s"
          style="
            visibility: visible;
            animation-delay: 0.3s;
            animation-name: bounceInUpSlow;
          "
        >
          <a href="##">
            <div class="icon">
              <img src="@/assets/images/speed-img03.png" alt="" />
            </div>
            <h4>签约产品</h4>
            <p>在应用详情页面，选择应用需要产品后提交申请</p>
          </a>
        </li>
        <li
          class="bounceInUpSlow wow"
          data-wow-delay="0.45s"
          style="
            visibility: visible;
            animation-delay: 0.45s;
            animation-name: bounceInUpSlow;
          "
        >
          <a href="##">
            <div class="icon">
              <img src="@/assets/images/speed-img04.png" alt="" />
            </div>
            <h4>开发测试</h4>
            <p>开发者按照开发指南、接口文档进行接口开发</p>
          </a>
        </li>
        <li
          class="bounceInUpSlow wow"
          data-wow-delay="0.6s"
          style="
            visibility: visible;
            animation-delay: 0.6s;
            animation-name: bounceInUpSlow;
          "
        >
          <a href="##">
            <div class="icon">
              <img src="@/assets/images/speed-img05.png" alt="" />
            </div>
            <h4>产品上线</h4>
            <p>测试后提交上线申请，审核通过后即可上线</p>
          </a>
        </li>
      </ul>
      <a
        @click="linkToRegister"
        class="enter-link waves-click bounceInUpSlow wow"
        data-wow-delay="0.5s"
        style="
          visibility: visible;
          animation-delay: 0.5s;
          animation-name: bounceInUpSlow;
        "
        >入驻我们</a
      >
    </div>
  </div>
</template>
<script setup>
const linkToRegister = () => {
  $$.router.push({ name: "register" });
};
</script>
<style lang="less" scoped></style>
